export default "__VITE_ASSET__kMP0xqSD__"